import Checkbox from '@components/ui/checkbox/checkbox';
export default Checkbox;
